import type { PricingCatalogFeature } from 'app/services/pricingCatalog';
import { formatFeatureValue } from 'app/pages/PlanAndPayment/ComparePlansModal/formatFeatureValue';

type ExploreSummaryFeature = {
  code: string;
  label: string;
  enabled: boolean;
};

export const formatExploreSummaryFeature = (
  feature: PricingCatalogFeature,
): ExploreSummaryFeature => ({
  code: feature.code,
  label: summaryLabelFor(feature),
  enabled: feature.availability !== 'unavailable',
});

const summaryLabelFor = (feature: PricingCatalogFeature): string => {
  switch (feature.code) {
    case 'jusfy_ai':
      if (feature.availability === 'unlimited') {
        return 'Mensagens ilimitadas na IA da Jusfy';
      }
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} mensagens na IA da Jusfy`;
      }
      return feature.label;
    case 'legal_queries':
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} consultas jurídicas`;
      }
      return feature.label;
    case 'legal_calculations':
      if (feature.availability === 'unlimited') {
        return 'Cálculos jurídicos ilimitados';
      }
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} cálculos jurídicos`;
      }
      return feature.label;
    case 'prospecting':
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} oportunidades de prospecção`;
      }
      return feature.label;
    case 'subusers':
      if (feature.availability === 'unavailable') {
        return 'Sem subusuários';
      }
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} subusuários`;
      }
      return feature.label;
    case 'drive_storage':
      if (feature.availability === 'limited' && feature.value != null) {
        return `${feature.value} GB de armazenamento no Drive`;
      }
      return feature.label;
    default:
      return genericSummaryLabelFor(feature);
  }
};

// Itens sem copy dedicada (hoje: itens do jussub, cujo code é o id do item) — mostra o
// total do item no plano. Sem a unidade: o nome do item já diz o que é (senão sairia
// "20 consultas Consultas Jurídicas").
const genericSummaryLabelFor = (feature: PricingCatalogFeature): string => {
  switch (feature.availability) {
    case 'limited':
      return feature.value != null ? `${feature.value} ${feature.label}` : feature.label;
    case 'unlimited':
    case 'addon':
      return `${formatFeatureValue(feature)} ${feature.label}`;
    default:
      return feature.label;
  }
};
